/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryDto } from '../../models/history-dto';

export interface HistoryAdminControllerFindAllV1$Params {
}

export function historyAdminControllerFindAllV1(http: HttpClient, rootUrl: string, params?: HistoryAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, historyAdminControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HistoryDto>>;
    })
  );
}

historyAdminControllerFindAllV1.PATH = '/api/v1/histories/admin/all';
